import { z } from 'zod'

export const CONNECTION_INFO_TYPES = {
  rtmp: 'rtmp',
  srt: 'srt',
  webRtc: 'webrtc',
} as const
export const connectionInfoTypeSchema = z.nativeEnum(CONNECTION_INFO_TYPES)
export type ConnectionInfoType = z.infer<typeof connectionInfoTypeSchema>

const baseConnectionInfoSchema = z.object({
  time: z.string(),
  clientIpAddress: z.string(),
  bytesReceived: z.number(),
})

export const rtmpConnectionInfoSchema = baseConnectionInfoSchema.extend({
  type: z.literal(CONNECTION_INFO_TYPES.rtmp),
})
export type RtmpConnectionInfo = z.infer<typeof rtmpConnectionInfoSchema>

export const srtConnectionInfoSchema = baseConnectionInfoSchema.extend({
  type: z.literal(CONNECTION_INFO_TYPES.srt),
  srtLatency: z.number(),
  roundTripTime: z.number(),
  packetsReceived: z.number(),
  packetsDropped: z.number(),
  packetsLost: z.number(),
})
export type SrtConnectionInfo = z.infer<typeof srtConnectionInfoSchema>

export const webRtcConnectionInfoSchema = baseConnectionInfoSchema.extend({
  type: z.literal(CONNECTION_INFO_TYPES.webRtc),
  packetsReceived: z.number(),
  packetsLost: z.number(),
  jitter: z.number(),
})
export type WebRtcConnectionInfo = z.infer<typeof webRtcConnectionInfoSchema>

export const connectionInfoSchema = z.discriminatedUnion('type', [
  rtmpConnectionInfoSchema,
  srtConnectionInfoSchema,
  webRtcConnectionInfoSchema,
])
export type ConnectionInfo = z.infer<typeof connectionInfoSchema>
